import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {
  FC, useCallback, useRef, useState, ReactNode, ReactElement,
} from 'react';
import { Context } from './context';

type PromtContextPropsType = {
  children: ReactNode; // 👈️ added type for children
};

export const PromtContext: FC<PromtContextPropsType> = (props): ReactElement => {
  const cbReject = useRef<() => void>();
  const cbResolve = useRef<() => void>();
  const [open, setOpen] = useState(false);

  const showPrompt = useCallback(
    () => new Promise<void>((resolve, reject) => {
      cbReject.current = reject;
      cbResolve.current = resolve;
      setOpen(true);
    }),
    []
  );

  const close = useCallback(() => {
    if (cbReject.current) {
      cbReject.current();
    }
    setOpen(false);
  }, []);

  const confirm = useCallback(() => {
    if (cbResolve.current) {
      cbResolve.current();
    }
    setOpen(false);
  }, []);

  return (
    <Context.Provider value={ showPrompt }>
      { props.children }
      <Dialog open={ open } onClose={ close }>
        <DialogTitle id='alert-dialog-title'>Точно ?</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Вы внесли изменения и не сохранили их. Вы действительно хотите покинуть страницу?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={ close } autoFocus variant='contained'>
            Нет. Отмена
          </Button>
          <Button onClick={ confirm } variant='text'>
             ДА. Потерять изменения
          </Button>
        </DialogActions>
      </Dialog>
    </Context.Provider>
  );
};
